import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import routes from '~pages'
import { isUserLoggedIn } from '@/auth/utils'
import {
  checkRouteChangedGuard,
  extendRouteWithGuard,
  preserveMetaOnSameRouteQueryChange,
  switchWorkspaceGuard,
} from '@/router/guards'
import { publicPages } from '@/router/public-pages'
import Empty from '@/components/Empty.vue'

const nestedRoutesPrefixes = [
  'bookings',
  'transport',
  'request',
  'settings',
  'directory',
  'contracts',
  'tenders',
  'documents',
  'reports',
]

const nonPublicRoutes = setupLayouts(routes)
  .map((route) => ({
    ...route,
    path: route.path.startsWith('/') ? route.path.slice(1) : route.path,
  }))
  .filter((route) =>
    nestedRoutesPrefixes.some((nested) => route.path.startsWith(nested)),
  )

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/playground/tailwind',
      redirect: '/playground/design',
    },
    {
      path: '/w/:workspaceId',
      component: Empty,
      beforeEnter: switchWorkspaceGuard,
      children: nonPublicRoutes,
    },
    ...setupLayouts(routes).map((route) => extendRouteWithGuard(route)),
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to) => {
  const routeName = typeof to.name === 'string' ? to.name : ''

  const authRequired = !publicPages.reduce(
    (a, b) => a || RegExp(b).test(routeName),
    false,
  )

  if (authRequired && !isUserLoggedIn())
    return {
      name: 'login',
      query: { to: to.name !== 'index' ? to.path : undefined, ...to.query },
    }

  return true
})

router.beforeResolve(
  async (to, from) => {
    preserveMetaOnSameRouteQueryChange(to, from)

    return await checkRouteChangedGuard(to, from)
  },
)

// fixes errors on dynamically import modules https://vitejs.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event) => {
  console.error('vite:preloadError', event)
  window.location.reload()
})

export default router
